import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OcbExecutionModes } from '@app/core';
import { TranslateService } from '@ngx-translate/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-execution-mode-picker',
    templateUrl: './execution-mode-picker.component.html',
    styleUrls: ['./execution-mode-picker.component.scss'],
})
export class ExecutionModePickerComponent {

    @Input()
    public readOnly: boolean;

    @Input()
    public selectedItem: string;

    @Output()
    public selectedItemChange = new EventEmitter<string>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public executionModes: any[] = new Array<any>();
    public loading: boolean = true;

    public constructor(private translateService: TranslateService) {
        this.translateService.get('executionModes').subscribe(labels => {
            for (const em in OcbExecutionModes) {
                if (isNaN(Number(em))) {
                    this.executionModes.push({ name: labels[em], id: OcbExecutionModes[em] });
                }
            }
            this.loading = false;
        });
    }

    public onSelectedItemChange($event: { name: string, id: string }) {
        if ($event == null) {
            return;
        }
        this.selectedItemChange.emit($event.id);
    }
}
